/* eslint-disable @typescript-eslint/no-explicit-any */
import { useId } from 'react'
import Container from '../Container'
import Full from '../Full'
import TwoThirds from '../TwoThirds'
import TableOfContents from '~/components/Content/TableOfContents/TableOfContents'

import { useQuery } from '@tanstack/react-query'
import { getEntryById } from '~/lib/contensis/misc'

import { ComponentRenderer } from '../renderers/comp/tocComponents'
// import Loader from '~/components/UI/General/Loader/Loader'

const TOCLayout = ({ content, padding }: any) => {
  const id = useId()

  const { data } = useQuery({
    queryKey: ['layout-toc', content?.componentForTwoThirds?.sys?.id],
    queryFn: async () =>
      getEntryById(content?.componentForTwoThirds?.sys?.id || ''),
    enabled: !!content?.componentForTwoThirds?.sys?.id
  })

  // if (isLoading)
  //   return (
  //     <div className='py-l flex w-full justify-center'>
  //       <Loader fill={'#f5b6dc'} />
  //     </div>
  //   )
  // if (error) return <div>Error loading components</div>

  return (
    <>
      <Container
        columns='golden'
        padding={padding}
        config={{ ...content, verticalAlignment: 'top' }}
      >
        {!content?.reverseLayout && (
          <>
            <Full className='md:top-3xl md:sticky'>
              <TableOfContents
                containerId={content.contentId + '-' + id}
                showNested={content.showNested}
                altHeading={content.heading}
              />
            </Full>

            <TwoThirds>
              {content.componentForTwoThirds && data && (
                <ComponentRenderer
                  components={data}
                  layoutColour={content.backgroundColour || 'white'}
                  containerId={content.contentId + '-' + id}
                />
              )}
            </TwoThirds>
          </>
        )}
        {content?.reverseLayout && (
          <>
            <TwoThirds>
              {content.componentForTwoThirds && data && (
                <ComponentRenderer
                  components={data}
                  layoutColour={content.backgroundColour}
                  containerId={content.contentId + '-' + id}
                />
              )}
            </TwoThirds>

            <Full className='md:top-3xl md:sticky'>
              <TableOfContents
                containerId={content.contentId + '-' + id}
                showNested={content.showNested}
                altHeading={content.heading}
              />
            </Full>
          </>
        )}
      </Container>
    </>
  )
}

export default TOCLayout
